const SEED_FLAG = 'userApplicationsSeeded_v3';

// IDs that were injected by the v2 seed — remove them on upgrade.
const V2_MOCK_IDS = new Set(['159', '237', '2621', '305', '2371']);

const seedUserApplicationsIfNeeded = () => {
    if (localStorage.getItem(SEED_FLAG)) return;
    // Remove the old v2 seed flag so re-runs don't conflict.
    localStorage.removeItem('userApplicationsSeeded_v2');
    // Strip the old mock orders from any existing data.
    const existing = (() => {
        try { return JSON.parse(localStorage.getItem('userApplications') || '[]'); }
        catch { return []; }
    })();
    const cleaned = existing.filter((a) => !V2_MOCK_IDS.has(String(a.orderId)));
    localStorage.setItem('userApplications', JSON.stringify(cleaned));
    localStorage.setItem(SEED_FLAG, 'true');
};

export default seedUserApplicationsIfNeeded;
